<template>
  <div>
    <v-dialog
      v-model="dialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      transition="dialog-bottom-transition"
      content-class="item-booking-dialog"
      max-width="560"
      scrollable
    >
      <v-card v-if="item" tile>
        <v-toolbar dense flat class="flex-grow-0">
          <v-toolbar-title class="body-1 font-weight-bold text-truncate">
            {{ item.name }}
          </v-toolbar-title>

          <v-spacer />

          <v-btn icon @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider class="my-0" />

        <v-card-text class="pa-0" ref="scroller">
          <!--start item header-->
          <img
            class="item-image"
            :src="item.image || (images && images.productDefaultImage)"
            :alt="item.name"
            @click="
              $root.$emit('showImage', { src: item.image, alt: item.name })
            "
          />

          <div class="pa-4">
            <div
              class="product_description--text body-2"
              v-html="item.description"
            ></div>

            <h6 class="font-weight-bold body-2 mt-1">
              <span class="primary--text" v-if="groupDiscount">
                {{ itemPrice.afterDiscount | currency }}
              </span>
              <span
                :class="
                  groupDiscount
                    ? 'text-decoration-line-through text-muted'
                    : 'primary--text'
                "
              >
                {{ itemPrice.original | currency }}
              </span>
            </h6>

            <div
              v-if="enableDeposit && itemDeposit > 0"
              class="text-muted caption"
            >
              {{ $t("delivery.lang_includeDeposit") }}
              {{ itemDeposit | currency }}
            </div>

            <p
              v-if="!productInfoSettings.hideProductInfo"
              class="accent--text small mb-0 mt-1"
              style="width: auto; display: inline-block; cursor: pointer;"
              @click="details_dialog = true"
            >
              {{ $t("delivery.lang_productInfo") }}
            </p>
          </div>
          <!--end item header-->

          <v-divider class="my-0" />

          <div class="tertiary lighten-3 pt-3 pb-1 px-2">
            <v-card-text
              v-if="Array.isArray(item.sizes) && item.sizes.length !== 0"
              class="py-0 mb-3"
            >
              <span class="subheading">{{
                $t("delivery.lang_chooseSize")
              }}</span>

              <v-radio-group v-model="mealsize" column>
                <v-radio
                  v-for="size in item.sizes"
                  :key="size.id"
                  :value="size"
                >
                  <template v-slot:label>
                    <div>
                      {{ size.sizeName }}
                      <span class="accent--text font-weight-bold body-2">{{
                        (size.sellPrice + itemDeposit).toFixed(2) | currency
                      }}</span>

                      <div
                        v-if="enableDeposit && itemDeposit > 0"
                        class="text-muted caption"
                      >
                        {{ $t("delivery.lang_includeDeposit") }}
                        {{ itemDeposit | currency }}
                      </div>
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-card-text>

            <!-- start extras -->
            <v-expansion-panels
              v-if="
                Array.isArray(item.sizes) && item.sizes.length !== 0
                  ? mealsize
                  : true
              "
              v-model="openedPanel"
              style="z-index: 1 !important;"
              class="elevation-0 pa-0 ma-0"
              accordion
              flat
              @change="onPanelChange"
            >
              <v-expansion-panel
                v-for="tab in extraTabs"
                :key="tab.id"
                ref="panel"
                class="elevation-0 pa-0 mx-0 mb-3"
                style="z-index: 1 !important; border: 1px solid #d8d8d8;"
              >
                <v-expansion-panel-header class="elevation-0 px-4 py-0 ma-0">
                  <div class="d-flex justify-space-between pb-0 pl-0 pr-4 ma-0">
                    <div class="align-self-center">
                      <h5 class="font-weight-bold body-2 ma-0">
                        {{
                          tab.invertGarnishSelection
                            ? $t("generic.lang_without")
                            : ""
                        }}
                        {{ tab.tabName }}
                      </h5>

                      <div
                        v-if="chooseHint(tab)"
                        class="font-weight-meduim body-2 text-muted"
                      >
                        {{ chooseHint(tab) }}
                      </div>
                    </div>

                    <v-spacer></v-spacer>

                    <span
                      class="font-weight-bolder align-self-center"
                      :class="
                        (tab.maxChoose > 0 &&
                          totalAmountOfCurrentExtras(tab) >= tab.maxChoose) ||
                        tab.minChoose < 1
                          ? 'text-success'
                          : 'text-danger'
                      "
                    >
                      {{
                        tab.minChoose >= 1
                          ? $t("delivery.lang_required")
                          : $t("generic.lang_optional")
                      }}
                    </span>
                  </div>
                </v-expansion-panel-header>

                <v-expansion-panel-content class="pa-0 pt-3 ma-0 less-padding">
                  <!--start garnish grid-->
                  <div
                    v-if="showGarnishImages(tab)"
                    class="d-flex flex-wrap"
                    :style="
                      tab.garnish.length > 12
                        ? 'max-height: 400px; overflow-y: auto;'
                        : ''
                    "
                  >
                    <div
                      v-for="ext in tab.garnish"
                      :key="tab.id + '-' + ext.id"
                      class="garnish-card text-center pa-1"
                    >
                      <div
                        class="garnish-tile pa-1 rounded-lg"
                        :class="ext.amount > 0 ? 'booked-garnish' : ''"
                      >
                        <div
                          class="garnish-thumb"
                          @click="openGarnishImage(ext)"
                        >
                          <v-avatar
                            tile
                            size="72"
                            color="accent"
                            class="mb-1 rounded-lg"
                          >
                            <img
                              v-if="garnishImage(ext)"
                              :src="garnishImage(ext)"
                              :alt="ext.name"
                              loading="lazy"
                              decoding="async"
                              @error="markGarnishImageBroken(ext)"
                            />
                            <span v-else class="white--text title">
                              {{ garnishInitial(ext) }}
                            </span>
                          </v-avatar>

                          <div
                            v-if="tab.invertGarnishSelection && ext.amount > 0"
                            class="garnish-removed-overlay"
                          >
                            <v-icon color="error" :size="56">mdi-close</v-icon>
                          </div>
                        </div>

                        <div
                          class="body-2 garnish-name"
                          :style="
                            tab.invertGarnishSelection && ext.amount > 0
                              ? 'text-decoration: line-through;'
                              : ''
                          "
                        >
                          {{ ext.name }}
                        </div>
                        <div class="body-2 accent--text">
                          {{ ext.sell_price | currency }}
                        </div>

                        <div>
                          <v-btn
                            v-if="ext.amount > 0"
                            color="accent"
                            class="ma-0"
                            icon
                            outlined
                            rounded
                            x-small
                            @click="removeExtra(ext)"
                          >
                            <v-icon x-small>mdi-minus</v-icon>
                          </v-btn>

                          <span class="mx-2 body-2" v-if="ext.amount > 0">
                            {{ ext.amount }}
                          </span>

                          <v-btn
                            v-if="
                              ext.amount === 0 ||
                                (tab.maxChoose > 0 &&
                                  totalAmountOfCurrentExtras(tab) <
                                    tab.maxChoose) ||
                                tab.maxChoose === 0
                            "
                            color="accent"
                            class="ma-0"
                            icon
                            outlined
                            rounded
                            x-small
                            :disabled="
                              (tab.maxChoose > 0 &&
                                totalAmountOfCurrentExtras(tab) >=
                                  tab.maxChoose) ||
                                (tab.invertGarnishSelection && ext.amount > 0)
                            "
                            @click="addExtra(tab, ext)"
                          >
                            <v-icon x-small>mdi-plus</v-icon>
                          </v-btn>

                          <v-btn
                            v-else
                            color="success"
                            class="ma-0"
                            icon
                            outlined
                            rounded
                            x-small
                          >
                            <v-icon x-small>mdi-check</v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--end garnish grid-->

                  <!--start garnish list, tabs without images-->
                  <v-card
                    v-else
                    tile
                    elevation="0"
                    :height="tab.garnish.length > 10 ? '350px' : ''"
                    style="overflow-y: auto;"
                    width="100%"
                  >
                    <div
                      v-for="ext in tab.garnish"
                      :key="ext.id"
                      style="width: 100%;"
                      class="d-flex pa-1 py-2 mx-0 mb-1 justify-space-between"
                      :class="ext.amount > 0 ? 'booked-garnish' : ''"
                    >
                      <div
                        class="body-2 align-start"
                        :style="
                          tab.invertGarnishSelection && ext.amount > 0
                            ? 'text-decoration: line-through;'
                            : ''
                        "
                      >
                        {{ ext.name }}
                        <span class="body-2 accent--text ml-1">
                          ({{ ext.sell_price | currency }})
                        </span>
                      </div>

                      <div class="text-right mr-1">
                        <v-btn
                          v-if="ext.amount > 0"
                          color="accent"
                          class="ma-0"
                          icon
                          outlined
                          rounded
                          x-small
                          @click="removeExtra(ext)"
                        >
                          <v-icon x-small>mdi-minus</v-icon>
                        </v-btn>

                        <span class="mx-2 body-2" v-if="ext.amount > 0">
                          {{ ext.amount }}
                        </span>

                        <v-btn
                          v-if="
                            ext.amount === 0 ||
                              (tab.maxChoose > 0 &&
                                totalAmountOfCurrentExtras(tab) <
                                  tab.maxChoose) ||
                              tab.maxChoose === 0
                          "
                          color="accent"
                          class="ma-0"
                          icon
                          outlined
                          rounded
                          x-small
                          :disabled="
                            (tab.maxChoose > 0 &&
                              totalAmountOfCurrentExtras(tab) >=
                                tab.maxChoose) ||
                              (tab.invertGarnishSelection && ext.amount > 0)
                          "
                          @click="addExtra(tab, ext)"
                        >
                          <v-icon x-small>mdi-plus</v-icon>
                        </v-btn>

                        <v-btn
                          v-else
                          color="success"
                          class="ma-0"
                          icon
                          outlined
                          rounded
                          x-small
                        >
                          <v-icon x-small>mdi-check</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </v-card>
                  <!--end garnish list-->
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <!-- end extras -->
          </div>
        </v-card-text>

        <v-divider class="ma-0" />

        <v-card-actions class="pa-3 flex-nowrap">
          <div class="qty-control d-flex align-center flex-shrink-0 mr-3">
            <v-btn icon small color="accent" @click="minus">
              <v-icon small>mdi-minus</v-icon>
            </v-btn>

            <span class="mx-2 body-2 font-weight-bold">{{ amount }}</span>

            <v-btn icon small color="accent" @click="plus">
              <v-icon small>mdi-plus</v-icon>
            </v-btn>
          </div>

          <v-btn
            height="40px"
            elevation="0"
            color="accent"
            class="flex-grow-1"
            min-width="0"
            :disabled="isValidExtrasLimits(extraTabs)"
            @click="addToCart()"
          >
            {{ itemTotalPrice | currency }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <product-info-dialog
      v-if="item"
      v-model="details_dialog"
      :dialog="details_dialog"
      :item="item"
    />
  </div>
</template>

<script>
import itemBooking from "@/mixins/itemBooking";
import ProductInfoDialog from "@/components/Menu/ProductInfoDialog";

export default {
  name: "ItemBookingDialog",

  components: { ProductInfoDialog },

  mixins: [itemBooking],

  props: {
    value: Boolean,
    item: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      details_dialog: false,
      openedPanel: null
    };
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    groupDiscount() {
      if (!this.itemGroup) return 0;

      return this.isDelivery
        ? this.itemGroup["delivery discount"]
        : this.itemGroup["takeaway discount"];
    }
  },

  watch: {
    item: {
      immediate: true,
      handler(val) {
        this.resetBooking();
        this.openedPanel = null;

        if (val) {
          this.getExtras();
          this.openFirstTabWhenNoSize();
        }
      }
    },
    // picking a size rebuilds the tabs, open the first one right away
    mealsize(val) {
      if (!val) {
        this.openedPanel = null;
        return;
      }

      this.$nextTick(() => {
        if (!this.extraTabs.length) {
          this.openedPanel = null;
          return;
        }

        this.openedPanel = 0;
        // setting the model does not emit change, scroll it up ourselves
        this.onPanelChange(0);
      });
    },
    value(val) {
      // reopening the same item must start from a clean selection
      if (val) {
        this.resetBooking();
        this.openedPanel = null;
        this.getExtras();
        this.openFirstTabWhenNoSize();
      }
    }
  },

  methods: {
    // nothing to pick before the extras, open the first tab right away
    openFirstTabWhenNoSize() {
      if (Array.isArray(this.item.sizes) && this.item.sizes.length !== 0)
        return;
      if (!this.extraTabs.length) return;

      this.$nextTick(() => {
        this.openedPanel = 0;
        this.onPanelChange(0);
      });
    },

    chooseHint(tab) {
      if (tab.minChoose == 0 && tab.maxChoose == 0) return "";

      if (tab.minChoose == 1 && tab.maxChoose == 1) {
        return "(" + this.$t("delivery.lang_select") + " 1)";
      }

      if (tab.minChoose == 1 && tab.maxChoose > 1) {
        return "(" + this.$t("delivery.lang_selectAtLeast") + " 1)";
      }

      if (tab.maxChoose === tab.minChoose) {
        return (
          "(" + this.$t("delivery.lang_select") + " " + tab.minChoose + ")"
        );
      }

      return "";
    },

    openGarnishImage(ext) {
      const src = this.garnishImageFull(ext);

      if (src) this.$root.$emit("showImage", { src, alt: ext.name });
    },

    close() {
      this.dialog = false;
    },

    // scroll the opened panel up once the expand animation is done, otherwise
    // the content lands off screen and the panel looks laggy
    onPanelChange(index) {
      if (index === null || index === undefined) return;

      window.clearTimeout(this._scrollTimer);
      this._scrollTimer = window.setTimeout(() => {
        const panel = this.$refs.panel && this.$refs.panel[index];

        if (panel && panel.$el && panel.$el.scrollIntoView) {
          panel.$el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 320);
    }
  },

  beforeDestroy() {
    window.clearTimeout(this._scrollTimer);
  }
};
</script>

<!--the dialog is teleported to the app root, so this cannot be scoped-->
<style>
.v-dialog.item-booking-dialog:not(.v-dialog--fullscreen) {
  border-radius: 12px;
}
</style>

<style scoped>
.item-image {
  display: block;
  width: 100%;
  max-height: 240px;
  object-fit: cover;
  cursor: pointer;
}

.qty-control {
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  background: #fff;
}

.garnish-thumb {
  cursor: pointer;
}

.garnish-card {
  flex: 0 0 33.33%;
  max-width: 33.33%;
}

.garnish-tile {
  height: 100%;
}

.garnish-name {
  line-height: 1.2;
}

.garnish-thumb {
  position: relative;
  display: inline-block;
}

.garnish-removed-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.centered-input {
  width: 120px !important;
}

.centered-input >>> input {
  text-align: center;
}

.less-padding >>> .v-expansion-panel-content__wrap {
  padding: 0 10px 0 !important;
}

.booked-garnish {
  background-color: rgba(241, 120, 0, 0.3);
}
</style>
